import * as React from 'react';
import { useCustomSearchParams } from 'common/hooks/customSearchParams';
import { WATCH_LIST_QUERY_PARAMS } from 'pages/TrackAndTrace/constants';
import { CustomerFilter as CustomerFilterBase } from 'components/ContainerFilters';

export const CustomerFilter: React.FC = () => {
  const { searchParams, setSearchParams } = useCustomSearchParams(WATCH_LIST_QUERY_PARAMS, true);

  return (
    <CustomerFilterBase
      customers={searchParams.customers}
      setCustomers={(customers) => setSearchParams({ customers })}
    />
  );
};
CustomerFilter.displayName = 'TrackAndTrace.Controls.filters.CustomerFilter';
